import { render, staticRenderFns } from "./Verified.vue?vue&type=template&id=e6ec6bf4&scoped=true&"
import script from "./Verified.vue?vue&type=script&lang=js&"
export * from "./Verified.vue?vue&type=script&lang=js&"
import style0 from "./Verified.vue?vue&type=style&index=0&id=e6ec6bf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ec6bf4",
  null
  
)

export default component.exports